<div class="flex flex-col items-center justify-between gap-5 p-6">
  <div class="w-full">
    <div class="flex items-start justify-between gap-2">
      <mat-icon svgIcon="rocket" color="primary" class="w-5 h-5"></mat-icon>
      <span class="w-full font-medium">Boas-vindas ao Field Control</span>
      <mat-icon class="text-color-icon cursor-pointer" (click)="close()"> close </mat-icon>
    </div>

    <span class="font-normal text-sm text-color-text"
      >Aqui vai um vídeo curtinho pra te ajudar a dar os primeiros passos na plataforma. Bora?</span
    >
  </div>

  <div>
    <iframe
      width="730"
      height="365"
      [src]="videoUrl"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
  </div>

  <div class="flex justify-end items-center w-full">
    <button
      type="button"
      class="px-8 py-2 bg-color-primary rounded text-white border-none h-10 cursor-pointer font-semibold"
      slot="end"
      (click)="close()"
    >
      FECHAR
    </button>
  </div>
</div>
